import ReservationsCalendar from '@/components/reservations/calendar';

export default ReservationsCalendar;
